
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "autocomplete"
})
export default class Autocomplete extends BaseVue {
  @Prop({ default: () => [] })
  suggestions!: any[];
  @Prop({ default: () => "value" })
  valueKey!: string;
  @Prop()
  value!: string;
  @Prop()
  placeholder!: string;
  filterSuggestions: any[] = [];
  inputValue: string = "";
  
  @Watch("value")
  valueChange(val, oldVal) {
    this.inputValue = val;
  }

  debouncedGetData(value) {
    this.filterSuggestions = this.isNull(value)
      ? this.suggestions.slice(0)
      : this.suggestions.filter(
          item => item[this.valueKey].indexOf(value) != -1
        );
  }

  handleInput(value) {
    this.$emit("input", value);
    this.debouncedGetData(value);
  }

  handleFocus(event) {
    this.$emit("focus", event);
    this.debouncedGetData(this.value);
  }

  select(item) {
    this.$emit("input", item[this.valueKey]);
    this.$emit("select", item);
  }

  mounted() {}
}
